import { render } from "./PaymentFormButton.vue?vue&type=template&id=e8980d3e"
import script from "./PaymentFormButton.vue?vue&type=script&lang=js"
export * from "./PaymentFormButton.vue?vue&type=script&lang=js"
script.render = render

export default script